import '../assets/NcAppNavigationIconBullet-1_cBEwu8.css';
import { n } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const e = {
  name: "NcAppNavigationIconBullet",
  props: {
    color: {
      type: String,
      required: !0,
      validator(t) {
        return /^#?([0-9A-F]{3}){1,2}$/i.test(t);
      }
    }
  },
  emits: ["click"],
  computed: {
    formattedColor() {
      return this.color.startsWith("#") ? this.color : "#" + this.color;
    }
  },
  methods: {
    onClick(t) {
      this.$emit("click", t);
    }
  }
};
var i = function() {
  var o = this, r = o._self._c;
  return r("div", { staticClass: "app-navigation-entry__icon-bullet", on: { click: o.onClick } }, [r("div", { style: { backgroundColor: o.formattedColor } })]);
}, l = [], c = /* @__PURE__ */ n(
  e,
  i,
  l,
  !1,
  null,
  "91580127",
  null,
  null
);
const s = c.exports;
export {
  s as default
};
